import isElement from 'lodash/isElement.js';
import isFinite from 'lodash/isFinite.js';
import isString from 'lodash/isString.js';

import env from '../../utils/env/env.js';

/**
 * Finds the position of an element for a given selector and scrolls it so that align point of the element
 * is positioned relative to the equivalent align point within the window or scrollable container
 * @selectorOrElement: {string}: the DOM selector for the element
 * @selectorOrElement: {DOM node}: a DOM element
 * @focus: {boolean}: optionally focus on the selector element
 * @focus: {string}: optionally focus on an element matching the provided selector string
 * @config: {object}: defines destination alignment and any offset, duration of scroll
 */
export function scrollToElement(selectorOrElement, focus, config = {}) {
  if (!env.isClient) {
    return;
  }

  let el;

  if (isString(selectorOrElement)) {
    el = document.querySelector(selectorOrElement);
  } else if (isElement(selectorOrElement)) {
    el = selectorOrElement;
  }

  if (el) {
    setTimeout(() => {
      el.scrollIntoView({
        behavior: config.behavior || 'smooth',
        block: config.block || 'start',
      });
      if (focus) {
        const focusEl = isString(focus) ? document.querySelector(focus) : el;
        focusEl.focus();
      }
    }, 0);
  }
}

export function scrollTo(scrollY) {
  if (!env.isClient) {
    return;
  }

  if (isFinite(scrollY)) {
    window.scrollTo(0, scrollY);
  }
}
